export const imageBlockProps = {
	data: {
		type: Object,
		required: true,
	},
	editable: {
		type: Boolean,
		default: false,
	},
	active: {
		type: Boolean,
		default: false,
	},
	h5: {
		type: Boolean,
		default: false,
	},
};

export const imageBlockEmits = ['select'];
